export default "__VITE_ASSET__4_WEnkVm__"